<template>
  <div class="dislog">
    <drag-modal :visible="visible" :title='type==0?"查看":(type==1?"新增":"编辑")+"调解机构"' width='720px' @cancel="close();visible=false;">
      <a-form-model ref="newforms" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }" :rules="{}">
        <a-form-model-item label="调解机构名称" :rules="{ required: true, message: '请选择补充时间',trigger: 'blur'}" prop="title">
          <a-input v-model="form.title"   placeholder='请输入调解机构名称'  :disabled="type===0"/>
        </a-form-model-item>
        <a-form-model-item label="调解机构地址" :rules="{ required: true, message: '请选择省市区', trigger: 'change' }" prop="addr">
          <a-row>
            <a-cascader :disabled="type===0" :options="options" v-model="address" placeholder="请选择省市区" :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" @change="onChange" />
          </a-row>
          <a-row>
            <a-textarea v-model="form.addr" placeholder="请输入调解机构详细地址" :disabled="type===0" style="margin-top:10px;" />
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="调解立案要求">
          <a-textarea v-model="form.zcla_limit" placeholder="请输入调解立案要求" :disabled="type===0"  class="long"/>
        </a-form-model-item>
        <a-form-model-item label="联系人姓名">
          <a-input v-model="form.uname"   placeholder='请输入联系人姓名' :disabled="type===0"  />
        </a-form-model-item>
        <a-form-model-item label="联系电话">
          <a-input v-model="form.phone"   placeholder='请输入联系电话' :disabled="type===0"  />
        </a-form-model-item>
        <a-form-model-item label="其他要求备注">
          <a-textarea v-model="form.other_comment" placeholder="请输入其他要求备注" :disabled="type===0"  class="long"/>
        </a-form-model-item>  
        <a-form-model-item prop="files" :wrapper-col="{ span: 24 }" :rules="{ required: false, message: '请上传附件',trigger: 'change'}">
          <Upload :fList='form.files' @upFileAfter='lisUpload' Wid='140px' :edit="type==0" />
        </a-form-model-item>
      </a-form-model>
      <a-form-model-item v-if="type!=0" style="text-align:center;margin: 40px 0 0;">
        <a-button class="cancel" @click="close();visible=false;">取消</a-button>
        <a-button type="primary" @click="sub()" style="margin-left:20px;">提交</a-button>
      </a-form-model-item>
    </drag-modal>
  </div>
</template>
<script>
import { citySort } from '@/assets/js/unit'
import city from "@/assets/js/city.json"
import Upload from "@/components/uploads"
import { arbOrg } from '@/server/directory'
export default {
  props:{
    id:String,
    type:Number
  },
  data(){
    return {
      visible:false,
      address:[],
      loading:false,
      options: citySort(city),
      form:{
        title:'',
        province:'',
        city:'',
        area:'',
        addr:'',
        uname:'',
        phone:'',
        zcla_limit:'',
        files:[]
      }
    }
  },
  components: { Upload },
  methods:{
    close(){
      this.address=[];
      for (const key in this.form) {
        this.form[key] = key=='files'?[]:''
      }
    },
    getInfo(id) {
      arbOrg({
        id: id
      },'info').then((res) => {
        this.address = [res.info.province, res.info.city, res.info.area]
        for (const key in this.form) {
          this.form[key] = res.info[key]
        }
        this.loading = true;
      })
    },
    onChange(val) {
      this.address = val
      if (val.length > 0) {
        this.form.province = val[0]
        this.form.city = val[1]
        this.form.area = val[2] || ''
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    lisUpload(fileList) {
      this.$set(this.form, 'files', fileList)
    },
    sub(){
      this.$refs.newforms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          form.files = form.files.map(ele => {
            return ele.id || ele
          })
          if(this.type==2) form.id=this.id
          arbOrg(form,this.type==2?'edit':'add').then((res) => {
            this.$message.success({ content: (this.type==2?'编辑':'添加')+'成功' });
            this.$emit('resh')
            this.close()
            this.visible=false
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.long{
  height:100px;
}
</style>